module.exports = __webpack_public_path__ + "media/assets/images/flags/hu-5cbc10a27005cbe04f75d44c5210fb7c.svg";